const MAIN_PLATFORM_STATUSES = [
  { value: "to_be_scheduled", label: "To Be Scheduled" },
  { value: "scheduled", label: "Scheduled" },
  { value: "uploaded", label: "Uploaded" },
  { value: "published", label: "Published" },
  { value: "rejected", label: "Rejected" },
  { value: "presale_dm", label: "Presale DM" },
  { value: "presale_post", label: "Presale Post" },
  { value: "live_on_subs", label: "Live On Subs" },
  { value: "removed_by_platform", label: "Removed By Platform" },
  { value: "needs_to_re_edit", label: "Needs To Re-Edit" },
  { value: "re_edited", label: "Re-Edited" },
  { value: "ready_to_re_publish", label: "Ready To Re-Publish" },
  { value: "re_published", label: "Re-Published" },
  { value: "removed_dmca", label: "Removed DMCA" },
  { value: "removed_coactor_retired", label: "Removed (Co-actor Retired)" },
];

const PROMO_PLATFORM_STATUSES = [
  { value: "promo_posted", label: "Promo Of The Video Is Posted" },
  { value: "not_posted", label: "Not Posted" },
  { value: "scheduled", label: "Scheduled" },
  { value: "removed", label: "Removed" },
];

export const PLATFORMS = [
  {
    id: "members_area",
    label: "Members Area",
    emoji: "🔐",
    hasPrice: false,
    statuses: [
      { value: "free_members", label: "Free Members (Trailer + Info)" },
      { value: "basic_members", label: "Basic Members (Full Access)" },
      { value: "vip_members", label: "VIP Members (Premium)" },
      { value: "bts", label: "BTS (Behind The Scenes)" },
      { value: "not_available", label: "Not Available" },
    ],
  },
  { id: "onlyfans_vip", label: "OnlyFans VIP", emoji: "🔞", hasPrice: true, statuses: MAIN_PLATFORM_STATUSES },
  { id: "onlyfans_free", label: "OnlyFans Free", emoji: "🆓", hasPrice: true, statuses: MAIN_PLATFORM_STATUSES },
  {
    id: "justforfans",
    label: "JustForFans",
    emoji: "🍑",
    hasPrice: true,
    statuses: [...MAIN_PLATFORM_STATUSES, { value: "post_to_inner_circle", label: "Post to Inner Circle (4+ months)" }],
  },
  { id: "rawfuckclub", label: "RawFuckClub", emoji: "🔥", hasPrice: false, statuses: MAIN_PLATFORM_STATUSES },
  { id: "faphouse", label: "Faphouse", emoji: "🏠", hasPrice: true, statuses: MAIN_PLATFORM_STATUSES },
  { id: "top4fans", label: "Top4Fans", emoji: "⭐", hasPrice: true, statuses: MAIN_PLATFORM_STATUSES },
  { id: "darkfans", label: "DarkFans", emoji: "💩", hasPrice: true, statuses: MAIN_PLATFORM_STATUSES },
  { id: "video_store", label: "Video Store (DRM)", emoji: "🛒", hasPrice: true, statuses: MAIN_PLATFORM_STATUSES },
  { id: "x_twitter", label: "X/Twitter", emoji: "𝕏", hasPrice: false, contentType: "Promo", statuses: PROMO_PLATFORM_STATUSES },
  { id: "instagram", label: "Instagram", emoji: "📸", hasPrice: false, contentType: "Promo", statuses: PROMO_PLATFORM_STATUSES },
  { id: "tiktok", label: "TikTok", emoji: "🎵", hasPrice: false, contentType: "Promo", statuses: PROMO_PLATFORM_STATUSES },
  { id: "bluesky", label: "Bluesky", emoji: "🦋", hasPrice: false, contentType: "Promo", statuses: PROMO_PLATFORM_STATUSES },
  { id: "xhamster", label: "XHamster", emoji: "🐹", hasPrice: false, contentType: "Promo", statuses: PROMO_PLATFORM_STATUSES },
];